// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Rooms: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M18.894 18.382V5.737h-3.249V3l-.792.137-8.631 1.505.117.675-.117-.675-.522.1v13.503H3v1.368h3.285l8.586 1.268.774.119V7.105h1.899v12.636H21v-1.36h-2.106Zm-4.599 1.04-7.281-1.04V5.892l7.281-1.295V19.422Z" />
    <path d="M13.251 11.275h-1.35v2.299h1.35v-2.3Z" />
  </SvgIcon>
);

Rooms.activeColor = 'inherit';
Rooms.muiName = 'Rooms';
